import React from 'react';

/**
 * Shown at the top of the app when running in demo mode
 * (no Supabase credentials configured).
 */
const DemoModeBanner = () => (
  <div style={{
    background: 'linear-gradient(90deg, #FFD166, #ffb347)',
    color: '#1A535C',
    textAlign: 'center',
    padding: '0.5rem 1rem',
    fontSize: '0.9rem',
    fontWeight: 'bold',
    fontFamily: 'Comic Sans MS, cursive',
    borderBottom: '2px solid #e6a020',
    position: 'sticky',
    top: 0,
    zIndex: 200,
  }}>
    🎮 Demo Mode — Using sample data. Changes are not saved.
    &nbsp;|&nbsp;
    Admin: <code style={{ background: 'rgba(0,0,0,0.1)', borderRadius: 4, padding: '1px 6px' }}>admin_demo</code>
    &nbsp; Student: <code style={{ background: 'rgba(0,0,0,0.1)', borderRadius: 4, padding: '1px 6px' }}>student_demo</code>
    &nbsp; Password: <code style={{ background: 'rgba(0,0,0,0.1)', borderRadius: 4, padding: '1px 6px' }}>Demo1234</code>
  </div>
);

export default DemoModeBanner;
